// src/components/PrivateRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthProvider";

const PrivateRoute = () => {
  const { isReady, isAuthenticated } = useAuth();

  if (!isReady) {
    // Optional: return a loader/skeleton instead of null
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/Login" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
